import { Badge } from "../../components/ui/badge";

export type LabelCellOption = {
  value: string;
  display_name: string;
  color: string;
};

type LabelCellProps = {
  value: string | null | undefined;
  options: LabelCellOption[];
};

const LabelCell = ({ value, options }: LabelCellProps) => {
  if (value === null || value === undefined || value === "" || value === "null") {
    return <span className="text-muted-foreground">—</span>;
  }

  const match = (options || []).find((option) => option.value === value);

  // Value isn't a known label option: render the raw value as plain text.
  if (!match) {
    return <span className="text-foreground">{value}</span>;
  }

  return (
    <Badge
      variant="statusPill"
      className="text-foreground"
      style={{ backgroundColor: `${match.color}1A` }}
    >
      <span
        className="h-1.5 w-1.5 flex-shrink-0 rounded-full"
        style={{ backgroundColor: match.color }}
      />
      {match.display_name}
    </Badge>
  );
};

export default LabelCell;
